import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import deluxe from "../../../Assets/Hompage/deluxe/deluxe1 (3).jpg";
import premium from "../../../Assets/Hompage/Premium/premium (1).jpeg";
import UseTitle from "../../Hooks/UseTitle";
const Rooms = () => {
  UseTitle("Rooms Details");
  return (
    <div className="roomsBg md:h-[70vh] lg:h-screen py-20 md:p-10">
      <div className="flex justify-center mx-auto ">
        <div className="max-w-screen-xl mx-auto md:px-10 px-8">
          <div className="flex justify-center md:justify-start">
            <div className="nahid-title-designer">
              <h2 data-aos="zoom-in" className="text-[40px] mb-5">
                Luxery
              </h2>
              <h1
                data-aos="zoom-in-up"
                className="md:text-[40px] lg:text-[48px] text-[25px]  font-bold"
              >
                Rooms
              </h1>
            </div>
          </div>
          <p className="pt-10 pb-20 text-[18px] text-justify md:text-star">
            Our especially designed luxurious and comfortable AC rooms with
            modern exclusive furniture provide a welcome feeling to business
            personnel as well as individual travelers. Our classy designed &
            decorated rooms offer all possible comfort to guests. Each of our
            classy decorated air-conditioned rooms have spacious bath, hot &
            cold shower, intercom system, LED TV, round the clock satellite
            channels, standard toiletries and a lot more.
          </p>
        </div>
      </div>
      <div className="max-w-screen-xl mx-auto md:py-0 py-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 px-10 md:px-10">
          <div
            // data-aos="zoom-out"
            className="relative md:m-5 
          shadow-md hover:shadow-lg transition ease-in-out delay-150 
           hover:-translate-y-1 hover:scale-110 duration-300
          
          "
          >
            <Link to="/Deluxe_Room">
              <img src={deluxe} alt="Deluxe" className="relative z-1 " />

              <div className="z-10 absolute bottom-0 md:left-[5%] md:right-[5%] left-0 bg-gray-100  lg:w-[450px] opacity-75 ">
                <div className="p-5 ">
                  <h1 className="text-[#bb4f32] lg:text-[40px] text-[18px]">
                    Deluxe
                  </h1>
                  <p className="lg:text-[30px] text-[16px] text-[#bb4f32] font-thin">
                    300 Sft.
                  </p>
                </div>
              </div>
            </Link>
          </div>
          <div
            className="relative md:m-5 shadow-md hover:shadow-lg transition ease-in-out delay-150 
           hover:-translate-y-1 hover:scale-110 duration-300"
          >
            <Link to="/Premium_Room">
              <img src={premium} alt="Premium" className="relative z-1" />

              <div className="z-10 absolute bottom-0 md:left-[5%] md:right-[5%] left-0 bg-gray-100  lg:w-[450px] opacity-75 ">
                <div className="p-5 ">
                  <h1 className="text-[#bb4f32] lg:text-[40px] text-[18px]">
                    Premium
                  </h1>
                  <p className="lg:text-[30px] text-[16px] text-[#bb4f32] font-thin">
                    300 Sft.
                  </p>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Rooms;
